import { Route, SingleRoute } from '@lib/types/route';

const decodePathSegment = (segment: string) => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

export const routePathMatches = (
  routePath: string,
  pathname: string,
): boolean => {
  const routeSegments = routePath.split('/').filter(Boolean);

  const pathSegments = pathname
    .split('/')
    .filter(Boolean)
    .map(decodePathSegment);

  return (
    routeSegments.length === pathSegments.length &&
    routeSegments.every(
      (segment, index) =>
        segment.startsWith('$') ||
        segment.toLowerCase() === pathSegments[index].toLowerCase(),
    )
  );
};

export const wrapRoutesWithModulePath = <T extends Route>(
  routes: T[],
  modulePath: string,
): Route[] =>
  routes.map((route) =>
    route.children
      ? {
          ...route,
          children: wrapRoutesWithModulePath(route.children, modulePath),
        }
      : {
          ...route,
          path: `${modulePath}${route.path}`,
        },
  );

const routeSpecificity = (path: string) =>
  path.split('/').filter((segment) => segment && !segment.startsWith('$'))
    .length;

export const findMatchingRoute = (
  routes: Route[],
  pathname: string,
): SingleRoute | undefined =>
  routes
    .flatMap((route) => route.children ?? [route])
    .filter((route) => routePathMatches(route.path, pathname))
    .sort(
      (first, second) =>
        routeSpecificity(second.path) - routeSpecificity(first.path),
    )[0];
